import { render, staticRenderFns } from "./EditFolder.vue?vue&type=template&id=510f485a&v-on-clickaway=cancel&"
import script from "./EditFolder.vue?vue&type=script&lang=ts&"
export * from "./EditFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports